import { TalentBrowseCampaignConstraints, type TalentBrowseCampaignConstraintsProps } from "@/components/TalentBrowseCampaignConstraints";
import { TalentBrowse, type TalentBrowseProps } from "@/components/talentBrowse";

type TalentStepProps = {
    campaignConstraints: TalentBrowseCampaignConstraintsProps;
    browse?: TalentBrowseProps;
    loading: boolean;
};

/** List-step chrome: campaign constraints, then TalentBrowse. Empty-platform copy is page-owned. */
export function TalentStep({ campaignConstraints, browse, loading }: TalentStepProps) {
    const noPlatforms = !campaignConstraints.platforms.value.length;

    return (
        <div>
            <TalentBrowseCampaignConstraints {...campaignConstraints} />

            {noPlatforms ? (
                <div className="my-4 text-center italic">Choose a platform to see creators.</div>
            ) : browse ? (
                <TalentBrowse {...browse} isLoading={loading} empty="No creators match your filters." />
            ) : null}
        </div>
    );
}
